import type { ReactNode } from "react";

type PassthroughProps = { children: ReactNode };
type ContextProps = { children: ReactNode; value: Record<string, string> };

const GrabRoot = ({ children }: PassthroughProps) => children;
const GrabScreen = ({ children }: PassthroughProps) => children;
const GrabContext = ({ children }: ContextProps) => children;

export { GrabRoot, GrabScreen, GrabContext };
